import { useState, useEffect } from 'react'
import { throttle } from 'throttle-debounce'

interface WindowSize {
    width: number
    height: number
}

const useWindowResize = (): WindowSize => {
    const [windowSize, setWindowSize] = useState<WindowSize>({
        width: typeof window === 'undefined' ? 0 : window.innerWidth,
        height: typeof window === 'undefined' ? 0 : window.innerHeight,
    })

    useEffect(() => {
        const onResize = (): void => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            })
        }

        const resizeHandler = throttle(200, onResize)

        window.addEventListener('resize', resizeHandler)

        onResize()

        return () => window.removeEventListener('resize', resizeHandler)
    }, [])

    return windowSize
}

export { useWindowResize }
